module.exports = __FOREMAN_VENDOR__YUP__;